import React, { useState, useEffect } from "react";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import "../../Config/swal.css";

export default function AddProdcut() {
  const [userDetails, SetUserDetails] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const [loading, setLoading] = useState(false);
  const [taxesData, setTaxesdata] = useState([]);
  const [selectedTax1Id, setSelectedTax1Id] = useState(null);

  const [formValues, setFormValues] = useState({
    size: "",
    name: "",
    mm: "",
    inches: "",
    taxid: "",
    weight: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetTaxes`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setTaxesdata(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setTaxesdata([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlecancel = () => {
    setFormValues({
      size: "",
      name: "",
      mm: "",
      inches: "",
      taxid: "",
      weight: "",
    });
    setSelectedTax1Id([]);
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasAdd");

    const handleOffcanvasClose = () => {
      handlecancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose,
        );
      }
    };
  }, []);

  const taxOptions =
    taxesData &&
    taxesData.map((item) => ({
      value: item.id,
      label: item.name + item.taxrate,
    }));

  const handleTax1SelectChange = (selectedOption) => {
    setSelectedTax1Id(selectedOption);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      size: formValues.size,
      name: formValues.name,
      mm: formValues.mm,
      inches: formValues.inches,
      weight: formValues.weight,
      taxid: selectedTax1Id, // from your dropdown selection
    };

    console.log("Submitting payload:", payload);

    try {
      const response = await fetch(`${API_BASE_CRM_URL}AddProduct`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Response:", result);

      if (result.status) {
        setLoading(false);
        Swal.fire({
          title: "Product Added Successfully.",
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      console.error("Error submitting product:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="offcanvas offcanvas-end custom-offcanvas"
        tabIndex="-1"
        id="offcanvasAdd"
        aria-labelledby="offcanvasRightLabel"
      >
        <style>
          {`
                        .offcanvas.custom-offcanvas {
                            width: 400px !important; /* Adjust this as needed */
                        }

                        @media (max-width: 576px) {
                            .offcanvas.custom-offcanvas {
                            width: 70% !important; /* Adjust the percentage as needed */
                            }
                        }
                        `}
        </style>
        <div className="offcanvas-header">
          <h4>Add Product</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <hr />
        <div className="offcanvas-body ms-2">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-md-12 mb-2">
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  type="text"
                  name="name"
                  value={formValues.name}
                  onChange={handleChange}
                  placeholder="Enter Name"
                  required
                />
              </div>
              <div className="col-md-12 mb-2">
                <label className="form-label">
                  Size <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="size"
                  value={formValues.size}
                  onChange={handleChange}
                  placeholder="Enter size"
                  required
                />
              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label">Size in mm</label>
                <input
                  className="form-control"
                  type="text"
                  name="mm"
                  value={formValues.mm}
                  onChange={handleChange}
                  placeholder="Enter size in mm"
                />
              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label">Size in Inches</label>
                <input
                  className="form-control"
                  type="text"
                  name="inches"
                  value={formValues.inches}
                  onChange={handleChange}
                  placeholder="Enter size in inches"
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Weight</label>
                <input
                  className="form-control"
                  type="text"
                  name="weight"
                  value={formValues.weight}
                  onChange={handleChange}
                  placeholder="Enter weight"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Tax<span className="text-danger">*</span>
                </label>
                <div className="d-flex">
                  <Select
                    showSearch
                    placeholder="Choose tax"
                    value={selectedTax1Id || null}
                    onChange={handleTax1SelectChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={taxOptions}
                    style={{ flexGrow: 1, height: "2.4rem" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary ms-2"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Product"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
